//La función del componente es mostrar un mensaje de error si el usuario no se encuentra conectado a EBM.

import './MensajeConexion.css'

const MensajeConexion = () => {
  return (
    <div className="row">
      <div className="col">
        <div className="contenedorLogin">
          <p className="mensajeLogin">Debes iniciar sesión en EbuyMarket</p>
        </div>
      </div>
    </div>
  )
}

export default MensajeConexion
